import { Box, Typography } from '@mui/material'
import LocationCard from 'src/pages/MUIBased/Appointments/components/LocationCard'
import { AppointmentProfile } from 'src/types'
import { useAmpliFeatureFlag } from 'src/AmplitudeExperimentProvider'

interface OfferingCardBottomProps {
    offering: AppointmentProfile
}

const OfferingCardBottom = ({ offering }: OfferingCardBottomProps) => {
    const sortedLocations = offering.clinicsWithOffering.sort((a, b) => {
        // sort by virtual first -- +(boolean) typecasts to 0 or 1
        // so if both are virtual or both are not, it will be 0 / falsey and will
        // skip sorting by virtual
        if (+b.isVirtual - +a.isVirtual) {
            return +b.isVirtual - +a.isVirtual
        }
        return a.name > b.name ? 1 : -1
    })

    const { enabled: isBookingMaintenanceMode } = useAmpliFeatureFlag(
        'booking-maintenance-mode'
    )

    return (
        <Box
            sx={{
                bgcolor: 'var(--mui-palette-primary-main)',
                color: 'var(--mui-palette-primary-contrastText)',
                p: 3
            }}
        >
            <Typography variant="h5" sx={{ mb: 2 }}>
                Choose where you want to have your appointment
            </Typography>
            {isBookingMaintenanceMode ? (
                <Box sx={{ color: 'white' }}>
                    Sorry, our booking service is down for scheduled
                    maintenance. Please check back after 9PM PT to book an
                    appointment.
                </Box>
            ) : (
                sortedLocations.map(clinic => (
                    <LocationCard
                        offering={offering}
                        clinic={clinic}
                        key={clinic.uuid}
                    />
                ))
            )}
        </Box>
    )
}

export default OfferingCardBottom
